import { CustomOutletContext } from "components/Admin/CustomOutlet/CustomOutlet";
import { useContext, useEffect } from "react";
import {
  NavigateFunction,
  NavigateOptions,
  To,
  useLocation,
  useNavigate,
} from "react-router";

export const useCustomNavigation = (props: { delay: number } | undefined = undefined) => {
  const context = useContext(CustomOutletContext);

  useEffect(() => {
    if (
      context === undefined ||
      props === undefined ||
      (context?.delay && context.delay >= props.delay)
    )
      return;

    context?.setDelay(props.delay);
  }, [context, props]);

  const navigate: NavigateFunction = useNavigate();

  const location = useLocation();

  const customNavigate: NavigateFunction = (
    arg1: To | number,
    arg2?: NavigateOptions
  ) => {
    if (typeof arg1 === "number") {
      return navigate(arg1);
    }

    if (typeof arg1 === "string") {
      return navigate({ pathname: arg1, search: location.search });
    }

    return navigate({ search: location.search, ...arg1 }, arg2);
  };

  return { navigate: customNavigate, state: context?.state ?? "show" };
};
